//import _ from 'underscore';
import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./per-capita.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default (function () {
	return {
		restrict: 'A',
		template: templateStr,
		transclude: true,
		scope: {
			hideForm: '&',
			type: '=',
			jobNumber: '=',
			policy: '=',
			edit: '=',
			perCapitaClassFixedId: '=',
			fullTimePerCapitaValue: '=',
			sharedClass: '=',
			auditPayrollResults: '=',
			partTimeLength: '=',
			perCapitaRecords: '=',
			partTimeRecordReady: '='
		},

		controller: ['$scope', '$rootScope', 'policy.PolicyService', 'ModalService', 'ViewModelService', '$state', '$filter', 'CancellationService', '$stateParams', function ($scope, $rootScope, PolicyService, ModalService, ViewModelService, $state, $filter, CancellationService, $stateParams) {

			$scope.count = 0;
			setTimeout(function () {}, 6000);
			$scope.coveredEmp = $scope.sharedClass;
			$scope.employeeList = [];

			var actualDate = new Date($stateParams.startDate);
			var actualEndDate = new Date($stateParams.endDate);

			var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
			var updateStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate()
			};
			$scope.startDate = updateStart;

			var updateEndStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate() - 1
			};
			$scope.endStartDate = updateEndStart;
			var updateEnd = {
				year: actualEndDate.getFullYear(),
				month: actualEndDate.getMonth(),
				day: actualEndDate.getDate()
			};
			var limitEnd = {
				year: actualEndDate.getFullYear(),
				month: actualEndDate.getMonth(),
				day: actualEndDate.getDate() - 1
			};
			var limitStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate() - 1
			};
			$scope.limitStart = limitStart;
			$scope.endDate = updateEnd;
			$scope.limitEnd = limitEnd;
			$scope.employeeInValid = true;
			//Function to add per capita row
			$scope.addRow = function () {

				var rowData = {};
				var start = new Date($scope.startDate.year, $scope.startDate.month, $scope.startDate.day);
				var end = new Date($scope.endDate.year, $scope.endDate.month, $scope.endDate.day);

				PolicyService.getPartTimeNumberOfDays($stateParams.jobNumber, $stateParams.startDate, $stateParams.endDate).then(function (res) {

					rowData.days = res.noOfDays;
				});

				$scope.count = $scope.count + 1;
				rowData.name = "";
				if (rowData.name == '' || rowData.name == undefined) {
					$scope.employeeInValid = true;
				} else {
					$scope.employeeInValid = false;
				}

				if ($scope.startDate.year) {
					var start = new Date($scope.startDate.year, $scope.startDate.month, $scope.startDate.day);
					rowData.startDate = moment(start).format("MM/DD/YYYY");
				} else {
					rowData.startDate = moment($scope.startDate).format("MM/DD/YYYY");
				}
				rowData.isStartDateEditable = true;
				rowData.isEndDateEditable = true;
				if ($scope.endDate.year) {
					var end = new Date($scope.endDate.year, $scope.endDate.month, $scope.endDate.day);
					rowData.endDate = moment(end).format("MM/DD/YYYY");
				} else {
					rowData.endDate = moment($scope.endDate).format("MM/DD/YYYY");
				}
				rowData.id = $scope.count;
				rowData.totalHours = "";
				if (rowData.totalHours == '' || rowData.totalHours == undefined) {
					$scope.employeeInValid = true;
				} else {
					$scope.employeeInValid = false;
				}
				//rowData.days=diffDays;
				$scope.employeeInValid = true;
				$scope.employeeList.push(rowData);
			};
			//check related record
			$scope.relatedRecord = function (employee) {

				if (!employee.fixedId) return true;
				if (employee.fixedId == $scope.perCapitaClassFixedId) {
					return true;
				}
				return false;
			};

			//Function to validate per capita row
			$scope.validateRow = function (emp) {
				if (emp.name == "") {
					return false;
				}
				//validate total hours field to disable OK button
				if (emp.totalHours == "") {
					return false;
				}
				if (emp.startDate == null || emp.endDate == null) {
					return false;
				} else {
					return true;
				}
				//check total hours error
				if (emp.totalHours != "" && emp.totalHours != undefined) {
					if (emp.totalHours !== '' || emp.totalHours !== null) {
						if (validNumber.test(emp.totalHours) === false) {
							return false;
						}
					}
				} else {
					return false;
				}
				return true;
			};
			//all percapita records to display

			//get part time per capita
			var alltypes = ['Employees', 'Family Member', 'Owner Officer'];
			$scope.allPerCapitaRecords = [];
			var allTypesLength = alltypes.length;
			angular.forEach(alltypes, function (classType) {
				allTypesLength--;
				if ($scope.auditPayrollResults) {
					angular.forEach($scope.auditPayrollResults.payrollData, function (payroll) {
						if (payroll.partTime) {
							var resLength = payroll.partTime.length;
							angular.forEach(payroll.partTime, function (partTime) {
								resLength--;
								var actualDate = new Date(partTime.startDate);
								var actualEndDate = new Date(partTime.endDate);
								var start = {
									year: actualDate.getFullYear(),
									month: actualDate.getMonth(),
									day: actualDate.getDate()
								};

								var end = {
									year: actualEndDate.getFullYear(),
									month: actualEndDate.getMonth(),
									day: actualEndDate.getDate()
								};
								$scope.count = $scope.count + 1;
								var rowData = {};
								rowData.fixedId = partTime.classFixedId;
								rowData.name = partTime.name;
								rowData.startDate = start;
								rowData.endDate = end;
								rowData.id = $scope.count;
								rowData.days = partTime.days;
								rowData.totalHours = partTime.totalHours;
								rowData.type = classType;
								//DEF2712
								rowData.isStartDateEditable = partTime.isStartDateEditable;
								rowData.isEndDateEditable = partTime.isEndDateEditable;
								$scope.allPerCapitaRecords.push(rowData);
								if (allTypesLength == 0 && resLength == 0) {
									$scope.$emit('partTimePerCapitaEmployees', $scope.allPerCapitaRecords);
								}
							});
						}
					});
				}
			});

			//Change diff days when change in datepicker
			$scope.$on('dateChanged', function (data, val) {
				$scope.tempList = [];
				var id = 'Hours' + val.id;
				setTimeout(function () {
					angular.element('#' + id).trigger('click');
				}, 100);
			});
			//updateTempList
			$scope.updateTempList = function (res, emp) {
				var valid = $scope.validateRow(res);
				if (valid == false) {
					$scope.employeeInValid = true;
				}

				if (res.id == emp.id) {
					$scope.tempList.push(emp);
				} else {
					$scope.tempList.push(res);
				}
			};
			//Save row data
			$scope.onSave = function (emp, type) {

				if ($scope.employeeList) {
					angular.forEach($scope.employeeList, function (empList) {
						if (empList.name == '' || empList.totalHours == '' || empList.startDate == null || empList.endDate == null || empList.name == '' && empList.totalHours == '') {
							$scope.employeeInValid = true;
						} else {
							$scope.employeeInValid = false;
						}
					});
				}

				var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
				var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
				var termEffectiveDate = new Date($scope.startDate.year, $scope.startDate.month, $scope.startDate.day);

				$scope.startDateVal = new Date(emp.startDate).toISOString();
				$scope.endDateVal = new Date(emp.endDate).toISOString();
				var termEffectiveDateString = new Date(termEffectiveDate).toISOString();

				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;

				//validate start date and end date to display validation message
				PolicyService.validateStartDate($scope.policy, $scope.startDateVal, termEffectiveDateString).then(function (startRes) {

					PolicyService.validateEndDate($scope.policy, $scope.startDateVal, $scope.endDateVal, termEffectiveDateString).then(function (endRes) {

						if (startRes == true) $scope.invalidStartDate = true;
						if (endRes == true) $scope.invalidEndDate = true;
						if (startRes == true && endRes == true) {
							$scope.invalidStartDate = true;
							$scope.invalidEndDate = true;
						}
						if (startRes != true && endRes != true) {
							//get no of days and reported percapita value on change of start date and disable submit button
							if (type && type == 'startDate') {
								PolicyService.updateDays($stateParams.jobNumber, $scope.startDateVal, $scope.endDateVal).then(function (res) {
									$scope.diffDays = res;
									if (res < 0) {
										$scope.negativeDate = true;
										emp.days = 0;
									} else emp.days = res;
								});
							}
							//get no of days and reported percapita value on change of end date and disable submit button
							if (type && type == 'endDate') {
								PolicyService.updateDays($stateParams.jobNumber, $scope.startDateVal, $scope.endDateVal).then(function (res) {
									$scope.diffDays = res;
									if (res < 0) {
										$scope.negativeDate = true;
										emp.days = 0;
									} else emp.days = res;
								});
							}
						}
					});
				});

				//get no of days and reported percapita value on change of start date 
				if (type && type == 'startDate') {
					PolicyService.validateStartDate($scope.policy, $scope.startDateVal, termEffectiveDateString).then(function (result) {
						if ($scope.employeeList) {
							angular.forEach($scope.employeeList, function (empList) {
								if (result == false && (empList.name == '' || empList.totalHours == '') || empList.name == '' && empList.totalHours == '') {
									$scope.employeeInValid = true;
								}
								if (result == true) {
									if (empList.name == '' && empList.totalHours == '') {
										$scope.employeeInValid = true;
									}
									if (empList.name == '') $scope.employeeInValid = true;
									if (empList.totalHours == '') $scope.employeeInValid = true;
								}
							});
						}
					});
				}

				//get no of days and reported percapita value on change of end date 
				if (type && type == 'endDate') {
					PolicyService.validateEndDate($scope.policy, $scope.startDateVal, $scope.endDateVal, termEffectiveDateString).then(function (result) {

						if ($scope.employeeList) {
							angular.forEach($scope.employeeList, function (empList) {
								if (result == false && (empList.name == '' || empList.totalHours == '') || empList.name == '' && empList.totalHours == '') {
									$scope.employeeInValid = true;
								}
								if (result == true) {
									if (empList.name == '' && empList.totalHours == '') {
										$scope.employeeInValid = true;
									}
									if (empList.name == '') $scope.employeeInValid = true;
									if (empList.totalHours == '') $scope.employeeInValid = true;
								}
							});
						}
					});
				}

				//emp.days=diffDays;
				$scope.tempList = [];
				$scope.negativeDate = false;

				angular.forEach($scope.employeeList, function (res) {
					if (res.fixedId) {
						if (res.fixedId == $scope.perCapitaClassFixedId) {
							$scope.updateTempList(res, emp);
						}
					} else {
						$scope.updateTempList(res, emp);
					}
				});
				var id = 'endDate' + emp.id + " :input";
				if ($scope.diffDays < 0) {
					angular.element('#' + id).css('border-color', '#b94a48');
					$scope.negativeDate = true;
					$scope.employeeInValid = true;
				} else if ($scope.diffDays == 0) {
					angular.element('#' + id).css('border-color', '#ccc');
				} else {
					angular.element('#' + id).css('border-color', '#ccc');
				}
				$scope.employeeList = $scope.tempList;
			};
			//Function to remove per capita row
			$scope.removeRow = function (id) {

				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;
				$scope.employeeInvalid = false;
				$scope.tempList = [];
				angular.forEach($scope.employeeList, function (res) {

					if (res.id != id) {
						$scope.tempList.push(res);
					}
				});
				$scope.employeeList = $scope.tempList;

				angular.forEach($scope.employeeList, function (result) {

					$scope.validateOnRemove(result, 'startDate');
				});
			};

			$scope.validateOnRemove = function (result, type) {

				if (result.name == '' || result.name == undefined || result.startDate == null || result.endDate == null || result.totalHours == "") {

					$scope.employeeInValid = true;
				} else {
					$scope.employeeInValid = false;
				}
			};

			//close screen and go to enter and validate screen
			$scope.close = function () {

				if ($scope.employeeList != 0) {
					$scope.$emit('closePartTimeCapita');
				} else {
					$scope.$emit('closePartTimeCapitaEmpty');
				}
			};
			//get part time per capita

			if ($scope.sharedClass) {
				var res = $scope.sharedClass.partTime;
				angular.forEach(res, function (data) {
					var actualDate = new Date(data.startDate);
					var actualEndDate = new Date(data.endDate);
					var start = {
						year: actualDate.getFullYear(),
						month: actualDate.getMonth(),
						day: actualDate.getDate()
					};

					var end = {
						year: actualEndDate.getFullYear(),
						month: actualEndDate.getMonth(),
						day: actualEndDate.getDate()
					};
					$scope.count = $scope.count + 1;
					var rowData = {};
					rowData.fixedId = data.classFixedId;
					rowData.name = data.name;
					rowData.startDate = moment(actualDate).format("MM/DD/YYYY");
					rowData.endDate = moment(actualEndDate).format("MM/DD/YYYY");
					rowData.id = $scope.count;
					rowData.days = data.days;
					//DEF2712
					rowData.isStartDateEditable = data.isStartDateEditable;
					rowData.isEndDateEditable = data.isEndDateEditable;
					rowData.totalHours = data.totalHours;
					if (rowData.totalHours === 0 || rowData.totalHours === '0') {
						$scope.employeeInValid = false;
					}

					if (rowData.name == '' || rowData.name == undefined || rowData.totalHours == '' || rowData.totalHours == undefined) {
						$scope.employeeInValid = true;
					} else {
						$scope.employeeInValid = false;
					}
					$scope.employeeList.push(rowData);
				});
			}

			//Function to submit per capita
			$scope.onSubmit = function () {
				$scope.finalList = [];

				angular.forEach($scope.employeeList, function (emp) {
					var row = {};
					if (emp.startDate.year && emp.endDate.year) {
						var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
						var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
						row.id = "0908";
						row.startDate = start;
						row.endDate = end;
						row.name = emp.name;
						row.totalHours = emp.totalHours;
						row.days = emp.days;
						//setting up editable boolean values
						row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
						row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
						row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
						row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;
						$scope.finalList.push(row);
					} else {
						var start = new Date(emp.startDate).toISOString();
						var end = new Date(emp.endDate).toISOString();
						row.id = "0908";
						row.startDate = start;
						row.endDate = end;
						row.name = emp.name;
						row.totalHours = emp.totalHours;
						row.days = emp.days;
						//setting up editable boolean values
						row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
						row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
						row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
						row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;
						$scope.finalList.push(row);
					}
				});
				$scope.sharedClass.partTime = $scope.finalList;
				$scope.$emit('closePartTimeCapita');
			};
			$scope.getDate = function (res) {
				var dateFinal = new Date(res.year, res.month, res.day);
				return dateFinal;
			};

			$scope.allowDateFormat = function (event, field) {

				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;
				setTimeout(function () {

					if (event.target.id == 'startDate') {

						$scope.onSave(field, event.target.id);
					}
					if (event.target.id == 'endDate') {

						$scope.onSave(field, event.target.id);
					}
				});

				if (event.keyCode == 47) {

					return false;
				} else if (event.keyCode < 48 || event.keyCode > 57) {
					event.preventDefault();
				}
			};

			//Restrict Alphabets
			$scope.restrictAlphabets = function (event, field) {

				if (event.keyCode == 46) {
					if (event.value && event.value.indexOf('.') >= 0) {
						if (event.value && event.value.length >= 2) {

							return false;
						}
						return true;
					} else if (event.value && event.value.indexOf('..') >= 0) {

						return false;
					} else {

						return false;
					}
				} else if (event.keyCode < 48 || event.keyCode > 57) {
					event.preventDefault();
				}
			};
			//form date

			$scope.formatDateDisplay = function (date) {

				return moment(date).format('MM/DD/YYYY');
			};
		}]

	};
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PerCapitaDirective_MSF/PerCapita.js
// module id = 1753
// module chunks = 0